import { Box, useMediaQuery, useTheme } from '@mui/material'
import { FC, ReactNode } from 'react'

import { AppLogo } from '@app/components/AppLogo'

type Props = {
  width?: number
  children: ReactNode
}

/**
 * Shared logo + white card shell used by all invite accept/decline pages
 * (public token-based and authenticated).
 */
export const InvitePageShell: FC<Props> = ({ width = 500, children }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box
      bgcolor="grey.200"
      width="100%"
      height="100%"
      p={10}
      display="flex"
      flexDirection="column"
      alignItems="center"
      overflow="scroll"
    >
      <AppLogo width={80} height={80} />
      <Box
        mt={5}
        bgcolor="common.white"
        py={3}
        px={3}
        borderRadius={2}
        width={isMobile ? undefined : width}
      >
        {children}
      </Box>
    </Box>
  )
}
